import React from 'react';

import { ButtonProps } from '@/components/shadcn/ui/button';
import { ConnectedEvmWallet } from '@/networks/evm';

const HeaderWalletDrawerEvmWalletConnect: React.FC<ButtonProps> = (props) => {
  return <ConnectedEvmWallet {...props} />;
};

export default HeaderWalletDrawerEvmWalletConnect;
